import React from "react";
import { useTranslation } from "react-i18next";

// reactstrap components
import {
    Button,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Label,
    Form,
    Input,
    InputGroupText,
    InputGroup,
    FormFeedback
} from "reactstrap";

import Swal from "sweetalert2";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";


//import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

import * as commonFunc from 'scripts/common';

function RegisterStepEmail(props) {
    const { t } = useTranslation();

    //Création du schéma pour le paramètrage du formulaire

    const schema = yup.object().shape({
           email: yup.string().required(t("gal_reqFields")).email(t("gal_invalidEmail")).min(2, t("gal_minChar", [2])).max(128, t("gal_maxChar", [128])),
    }).required();

    //Paramètrage du formulaire
    const { register, getValues, setValue, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

    React.useEffect(() => {
        if (props.triggerAnimate) props.triggerAnimate();
    }, [props.shouldRender]);

    React.useEffect(() => {
        var email = getValues("email");
        if (props.email && email !== props.email) {
            setValue("email", props.email);
        }
    }, [props.email]);

    const getFingerprint = async () => {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        return result.visitorId;
    };


    function redirectExternalLogin(provider) {
        //Enregistrement du produit actuel en localStorage pour récupération extLogin
        localStorage.setItem("signUpProductId", props.productId);

        getFingerprint().then((fingerprint) => {
            //navigate("../ExternalLogin/ExternalLogin");
            window.location.assign('../ExternalLogin/ExternalLogin?provider=' + provider + '&deviceId=' + fingerprint);
        });
    }

    async function triggerSubmit(data) {
        Swal.fire({
            title: t("log_checkInfos"),
            didOpen: () => { Swal.showLoading() }
        });

        commonFunc.postMethod("../api/ValidateEmail", { email: data.email }).then((response) => {
            var result = response.data;
            if (result.isSuccess) {
                Swal.close();
                data.title = rSelected;
                data.provider = "Softena";
                if (props.updateStep) props.updateStep(data);
            }
            else if (result.errorCode === 400 || result.errorCode === 500) {
                Swal.fire({
                    icon: 'error',
                    title: t("gal_error"),
                    html: result.errorMessage,
                });
            }
        });
    }

    const [rSelected] = React.useState("M");

    const { ref: refEmail, ...restEmail } = register("email", { value: props.email });


    return (
        <Form action="" className="form needs-validation" method="" onSubmit={handleSubmit(triggerSubmit)}>
            <CardHeader className="bg-white">
                <CardTitle className='header my-0 py-0' tag="h5">{t("register_checkEmail")}</CardTitle>
            </CardHeader>
            <CardBody>
                <InputGroup className="single-input">
                    <InputGroupText className="mandatory">
                        <i className="fa fa-envelope" />
                    </InputGroupText>
                    <div className="form-floating min-input">
                        <Input id="inputemail" type="email" autoComplete="off" aria-autocomplete="none" placeholder={t("register_email")} innerRef={refEmail} {...restEmail} invalid={errors.email ? true : false} />
                        <Label for="inputemail">{t("register_email")}</Label>
                    </div>
                    <FormFeedback className={`text-start ${errors.email ? "d-block" : ""}`}>{errors.email ? errors.email.message : t("gal_reqFields")}</FormFeedback>
                </InputGroup>

                <div className="social mt-2 d-flex flex-column align-items-center justify-content-center w-100">
                    <p className="card-description mb-0">{t("register_or")}</p>
                    <Button title={t("register_authGoogle")} className="p-0 border border-gray border-1 btn-round d-flex align-items-center justify-content-center w-100" color="light" type="button" onClick={() => redirectExternalLogin("Google")}
                        style={{ maxWidth: "250px" }}>
                        <div className="bg-light2 d-flex align-items-center justify-content-center" style={{ height: "36px", width: "36px" }}>
                            <img
                                src={require('assets/img/icon/logo-google.png')}
                                height='18px'
                                alt=''
                                loading='lazy'
                                className=''
                            />
                        </div>
                        <div className="flex-grow-1 fw-normal text-dark" style={{ fontSize: "14px", textTransform: "none" }}>{t("register_googleBtn")}</div>
                    </Button>
                    <Button title={t("register_authMicrosoft")} className="p-0 border border-gray border-1 btn-round d-flex align-items-center justify-content-center w-100 mt-2 ms-0" color="light" type="button" onClick={() => redirectExternalLogin("Microsoft")}
                        style={{ maxWidth: "250px" }}>
                        <div className="d-flex align-items-center justify-content-center" style={{ height: "36px", width: "36px" }}>
                            <img
                                src={require('assets/img/icon/logo-microsoft.png')}
                                height='18px'
                                alt=''
                                loading='lazy'
                                className=''
                            />
                        </div>
                        <div className="flex-grow-1 fw-normal text-dark" style={{ fontSize: "14px", textTransform: "none" }}>{t("register_microsoftBtn")}</div>
                    </Button>
                    <Button className="btn-icon btn-round hidden" color="facebook" type="button" onClick={() => redirectExternalLogin("Facebook")}>
                        <i className="fa-brands fa-facebook-f" />
                    </Button>
                </div>

            </CardBody>
            <CardFooter className="text-end mt-0">
                <Button title={t("register_next")} className="btn-icon rounded-circle bg-altLink-color btn btn-primary" color="info"><i className="fa fa-arrow-right" style={{ fontSize: "1.6em" }}></i></Button>
            </CardFooter>
        </Form>
    );
}

export default RegisterStepEmail;
